'use client';

import { datadogRum } from '@datadog/browser-rum';

datadogRum.init({
  applicationId: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID!,
  clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN!,
  site: 'us5.datadoghq.com',
  service: 'ullr-web',
  env: process.env.NEXT_PUBLIC_ENV || 'development',
  version: process.env.NEXT_PUBLIC_VERSION || '0.0.0',
  sessionSampleRate: 100,
  sessionReplaySampleRate: 20,
  trackUserInteractions: true,
  trackResources: true,
  trackLongTasks: true,
  // Inject trace headers on API calls so browser RUM sessions join backend APM
  // traces (mobile already does this via firstPartyHosts).
  allowedTracingUrls: [
    {
      match: /^https:\/\/([a-z0-9-]+\.)?api\.ullr\.ski/,
      propagatorTypes: ['datadog', 'tracecontext'],
    },
  ],
});

export default function DatadogInit() {
  return null;
}
